const IcoArrow = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9.763" height="17.078" viewBox="0 0 9.763 17.078">
      <path id="Icon_ionic-ios-arrow-back" data-name="Icon ionic-ios-arrow-back" d="M14.194,14.73l6.462-6.457A1.22,1.22,0,0,0,18.927,6.55l-7.321,7.316a1.218,1.218,0,0,0-.036,1.683l7.351,7.367a1.22,1.22,0,1,0,1.729-1.723Z" transform="translate(-11.251 -6.194)" fill="current" />
    </svg>
  );
}

export default IcoArrow;